import React, { FC, useRef, RefObject } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { Paper, PaperProps } from '@mui/material';
import { Details } from 'components/table/profile/Details';
import CloseIcon from '@mui/icons-material/Close';

interface InfoProfileProps {
    setOpen : (value: boolean) => void;
    open : boolean;
    selected: any;
}

function PaperComponent(props: PaperProps) {
    const nodeRef = useRef<HTMLDivElement>(null);
    return (
        <Draggable
            nodeRef={nodeRef as RefObject<HTMLDivElement>}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const InfoProfile: FC<InfoProfileProps> = ({ setOpen, open, selected }) => {

    const { t } = useTranslation();

    return(
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >
        <DialogTitle sx={{ cursor: 'move' }} id="draggable-dialog-title">
            {t('profiles.table.dialog.info.title')}
        </DialogTitle>
        <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ height: 'calc(100% - 430px)', overflow: 'hidden' }}>
            <Details
                permissions={selected[0]?.permissions}
                views={selected[0]?.views}
                tags={selected[0]?.tags}
            />
        </DialogContent>
        <DialogActions>
            <Button autoFocus onClick={() => setOpen(false)} variant='contained' color='primary'>
                {t('profiles.table.dialog.info.buttons.close')}
            </Button>
        </DialogActions>
        </Dialog>
    )
}

export { InfoProfile }